<template>
  <component
    :is="customPageContentSidebarList"
    v-if="inSideBar && customPageContentSidebarList"
    :items="preparedItems"
    :highlight-exact-active="highlightExactActive"
  />
  <page-content-sidebar-list
    v-else-if="inSideBar"
    ref="pageContentSidebarListComponent"
    :items="preparedItems"
    :highlight-exact-active="highlightExactActive"
  />
  <main-sidebar-dropdown-menu
    v-else
    :items="preparedItems"
    :highlight-exact-active="highlightExactActive"
  />
</template>
<script setup lang="ts">
import { computed, ref } from '@/composition/vue/compositionApi'
import type { Component } from '@/composition/vue/compositionApi'
import PageContentSidebarList from '@/components/layout/pageContent/sidebar/PageContentSidebarList.vue'
import MainSidebarDropdownMenu from '@/components/layout/mainSidebar/MainSidebarDropdownMenu.vue'
import type { PageContentSidebarItem } from '@/components/layout/pageContent/sidebar/types'
import { prepareLayoutMenuItems, useLayoutMenuInSidebar } from '@/composition/layoutMenu'
import TmLogicError from '@/core/error/tmLogicError'

const props = defineProps<{
  items?: PageContentSidebarItem[]
  customPageContentSidebarList?: Component
  highlightExactActive?: boolean
}>()

const inSideBar = useLayoutMenuInSidebar().inject()

const pageContentSidebarListComponent = ref<InstanceType<typeof PageContentSidebarList> | null>(null)

const preparedItems = computed(() => {
  if (!props.items) {
    return []
  }
  return prepareLayoutMenuItems(props.items)
})

const changeIsOpenedGroupCollapsible = (itemKey: string, val: boolean) => {
  if (!pageContentSidebarListComponent.value) {
    throw new TmLogicError('pageContentSidebarList is null')
  }
  pageContentSidebarListComponent.value.changeIsOpenedGroupCollapsible(itemKey, val)
}

defineExpose({
  changeIsOpenedGroupCollapsible,
})
</script>
